import { axiosInstancePlano } from '../../../../core/api/planoAxios';
import { logger } from '../../../../core/utils/logger';
import { useUserStore } from '../../../Auth/stores/authStore';
import {
  HubProgress,
  HubReport,
  HubResume,
  HubWeekTime,
  IScheduleDayResponse,
  IUpdateHubSchedulePayload,
  ScheduleActivity,
  TPeriodSelector,
} from '../../model/ScheduleHub';

export const getResumo = async (id?: string): Promise<HubResume> => {
  try {
    const user = useUserStore.getState().user;

    if (!user) {
      throw new Error('Usuário não encontrado');
    }

    const { data } = await axiosInstancePlano.get(`/cronograma/hub/resumo/${id || user.id}`);

    return data;
  } catch (error: any) {
    if (id) {
      const user = useUserStore.getState().user;

      if (user?.id && user.id !== id) {
        try {
          const { data } = await axiosInstancePlano.get(
            `/cronograma/hub/resumo/${user.id}`
          );

          return data;
        } catch (fallbackError: any) {
          logger.error('PlanoAdaptativo.getResumoFallback', fallbackError);
        }
      }
    }

    logger.error('PlanoAdaptativo.getResumo', error);
    throw new Error(error);
  }
};

export const getDayActivities = async (
  idCronograma: string
): Promise<ScheduleActivity[]> => {
  try {
    const { data } = await axiosInstancePlano.get(
      `/cronograma/hub/day-activities/${idCronograma}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getWeekSchedule = async (
  idCronograma: string,
  startDate: Date,
  endDate: Date
): Promise<IScheduleDayResponse> => {
  try {
    const { data } = await axiosInstancePlano.get(
      `/cronograma/hub/week-schedule/${idCronograma}?startDate=${startDate}&endDate=${endDate}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getProgress = async (
  idCronograma: string,
  period: TPeriodSelector
): Promise<HubProgress> => {
  try {
    const { data } = await axiosInstancePlano.get(
      `/cronograma/hub/progress/${idCronograma}?period=${period}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getWeekSpendingTime = async (
  idCronograma: string
): Promise<HubWeekTime[]> => {
  try {
    const { data } = await axiosInstancePlano.get(
      `/cronograma/hub/week-spending-time/${idCronograma}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getReport = async (
  idCronograma: string,
  period: 'week' | 'month' | 'general'
): Promise<HubReport[]> => {
  try {
    const { data } = await axiosInstancePlano.get(
      `/cronograma/hub/report/${idCronograma}?period=${period}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateWeeklySchedule = async (
  idCronograma: string,
  fromDate: Date,
  toDate: Date,
  discipline: string,
  oldDate?: Date
) => {
  try {
    const { data } = await axiosInstancePlano.put(
      `/cronograma/hub/weekly-schedule/${idCronograma}`,
      { fromDate, toDate, discipline, oldDate }
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateHubSchedule = async (
  idCronograma: string,
  payload: IUpdateHubSchedulePayload
) => {
  try {
    const { data } = await axiosInstancePlano.put(
      `/cronograma/hub/${idCronograma}`,
      payload
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
